function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* eslint-disable */
// This icon has been generated. Do not edit it directly.


import React from 'react';

var IconInfo = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(IconInfo, _React$PureComponent);

  function IconInfo() {
    _classCallCheck(this, IconInfo);

    return _possibleConstructorReturn(this, _getPrototypeOf(IconInfo).apply(this, arguments));
  }

  _createClass(IconInfo, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          height = _this$props.height,
          color = _this$props.color,
          onClick = _this$props.onClick,
          size = _this$props.size,
          style = _this$props.style,
          width = _this$props.width,
          className = _this$props.className,
          rest = _objectWithoutProperties(_this$props, ["height", "color", "onClick", "size", "style", "width", "className"]);

      return React.createElement("svg", _extends({}, rest, {
        height: height || size,
        width: width || size,
        onClick: onClick,
        style: style,
        className: className,
        fill: color,
        viewBox: "0 0 512 512"
      }), React.createElement("path", {
        d: "M256 51.5C143.058 51.5 51.5 143.061 51.5 256S143.058 460.5 256 460.5c112.944 0 204.5-91.55 204.5-204.5 0-112.945-91.556-204.5-204.5-204.5zm-1.02 318.859s-9.49 6.311-15.977 6.282l-.918.419.014-.419a20.915 20.915 0 0 1-4.114-.601l-2.048-.508c-11.327-2.81-17.324-14.041-14.504-25.361l15.77-63.567 7.116-28.711c6.622-26.66-20.995 5.668-26.657-6.613-3.741-8.118 21.479-25.152 39.904-37.994 0 0 9.477-6.3 15.967-6.273.582-.27.926-.421.926-.421l-.023.421c1.372.061 2.744.253 4.125.595l2.049.509c11.325 2.81 18.224 14.269 15.413 25.591l-15.761 63.573-7.133 28.711c-6.607 26.657 20.549-5.795 26.206 6.503 3.741 8.106-21.935 25.026-40.355 37.864zm39.964-198.694c-3.937 15.854-19.979 25.523-35.825 21.584-15.86-3.935-25.529-19.972-21.59-35.831 3.935-15.862 19.974-25.522 35.829-21.587 15.854 3.932 25.521 19.975 21.586 35.834z"
      }));
    }
  }]);

  return IconInfo;
}(React.PureComponent);

_defineProperty(IconInfo, "styleRoot", 'IconInfo');

_defineProperty(IconInfo, "defaultProps", {
  size: 32,
  color: '#333'
});

export { IconInfo as default };